import { Option } from '../utils/Option'

import {
  BaseProductType,
  IconicRange,
  ProductOrientationSupport,
  SkinProductOption,
  TopLevelMenuCategory,
} from '../types/productTypes'
import SelectorScreenMenuType, {
  SwitchMenuOptions,
  SocketMenus,
  OtherMenuItems,
  OutdoorMenuItems,
  WiserMenus
} from './SelectorScreenMenuType'
import { getOutdoorTypeDisplayName, getRangeMenuDisplayName } from '../products/productDisplayUtils'
import { BaseProductTypeOrderMap, RangeSortOrderMap, TopLevelSortOrderMap } from '../products/SortOrders'

// Maps styles to a sorted list of options
const StyleOptions: readonly Option<IconicRange>[] = Object.keys(RangeSortOrderMap)
  .map(key => ({
    key: key as IconicRange,
    order: RangeSortOrderMap[key as IconicRange],
  }))
  .sort((a, b) => a.order - b.order)
  .map(({ key }) => ({
    key,
    label: getRangeMenuDisplayName(key),
  }))

export const OutdoorTypeOptions: readonly Option<BaseProductType>[] = ([
  'Switch', 'Socket', 'Other',
] as const)
  .map(key => ({
    key: key,
    order: BaseProductTypeOrderMap[key],
  }))
  .sort((a, b) => a.order - b.order)
  .map(({ key }) => ({
    key,
    label: getOutdoorTypeDisplayName(key),
  }))
export const OrientationOptions: readonly Option<ProductOrientationSupport>[] = [
  {
    key: 'Vertical',
    label: 'Vertical',
  },
  {
    key: 'Horizontal',
    label: 'Horizontal',
  },
]
export const TopLevelMenuOptions: readonly Option<TopLevelMenuCategory>[] = Object.keys(TopLevelSortOrderMap)
  .map(key => ({
    key: key as TopLevelMenuCategory,
    order: TopLevelSortOrderMap[key as TopLevelMenuCategory],
  }))
  .sort((a, b) => a.order - b.order)
  .map(({ key }) => ({
    key,
    label: getTopLevelCategoryMenuDisplayName(key),
  }))

export function getTopLevelCategoryDisplayName(type: TopLevelMenuCategory) {
  switch (type) {
    case 'Switch':
      return 'Switches'
    case 'Socket':
      return 'Power Points'
    case 'Other':
      return 'Accessories'
    case 'Outdoor':
      return 'Outdoor'
    case 'Wiser':
      return 'Wiser Smart Home'
  }
}

export function getTopLevelCategoryMenuDisplayName(type: TopLevelMenuCategory) {
  switch (type) {
    case 'Switch':
      return 'Switches'
    case 'Socket':
      return 'Power Points'
    case 'Other':
      return 'Accessories'
    case 'Outdoor':
      return 'Outdoor'
    case 'Wiser':
      return 'Wiser'
  }
}

export function getStyleMenuOptionsAvailableForUser(isConsumer: boolean, isPro: boolean) {
  if (isConsumer || !isPro) {
    return StyleOptions.filter(it => it.key !== 'Pro' && it.key !== 'Outdoor')
  }

  return StyleOptions.filter(it => it.key === 'Pro')
}

export function getProductsAvailableForUserAndSeries(allProducts: readonly SkinProductOption[], isConsumer: boolean, pro: boolean) {
  if (isConsumer || !pro) {
    return allProducts.filter(it => !it.pro)
  }

  return allProducts.filter(it => it.pro)
}

export function getAvailableMenusForTopLevelProductType(productType: TopLevelMenuCategory): Set<SelectorScreenMenuType> {
  switch (productType) {
    case 'Switch':
      return SwitchMenuOptions
    case 'Socket':
      return SocketMenus
    case 'Wiser':
      return WiserMenus
    case 'Outdoor':
      return OutdoorMenuItems
    case 'Other':
      return OtherMenuItems
  }
}

export function getDefaultMenuForTopLevelType(type: TopLevelMenuCategory): SelectorScreenMenuType {
  switch (type) {
    case 'Switch':
    case 'Socket':
    case 'Other':
      return SelectorScreenMenuType.Style
    case 'Outdoor':
      return SelectorScreenMenuType.OutdoorType
    case 'Wiser':
      return SelectorScreenMenuType.WiserType
  }
}